@if (isLoading) {
<app-loader></app-loader>
} @else {
<div class="block px-10">
	<div class="flex">
		<nz-page-header [nzTitle]="orderProcessTitle" class="p-0 m-0 mt-10">

            <nz-page-header-extra class="flex items-center">
                <!-- Mostrar "Iniciar turno" solo si el usuario NO está en la máquina O NO tiene turno activo -->
                @if ((!isCurrentUserAssignedToProcess() || !hasActiveShiftSession()) && (orderProcess.statusId === StatusEnum.IN_PROGRESS || orderProcess.statusId === StatusEnum.PAUSED)) {
                    <button (click)="swapUserInProcess()" class="flex items-center bg-yellow-100 border border-yellow-400 rounded-lg px-2 py-1 shadow-md animate-pulse max-w-xs z-10">
                        <span class="font-bold text-yellow-900 text-sm mr-2 flex items-center">
                            Iniciar turno
                        </span>
                        <div class=" text-white bg-yellow-500 hover:bg-yellow-600 focus:ring-2 focus:ring-yellow-300 font-bold rounded-lg text-xs p-1 shadow "
                            style="z-index: 30;">

                            <span class="flex items-center">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
                                </svg>
                            </span>
                        </div>
                    </button>
                <!-- Mostrar "Finalizar turno" solo si el usuario ESTÁ en la máquina Y tiene turno activo -->
                } @else if (isCurrentUserAssignedToProcess() && hasActiveShiftSession() && (orderProcess.statusId === StatusEnum.IN_PROGRESS || orderProcess.statusId === StatusEnum.PAUSED)) {
                    <button (click)="finalSesion()" class="flex items-center bg-cyan-100 border border-cyan-400 rounded-lg px-2 py-1 shadow-md max-w-xs z-10">
                        <span class="font-bold text-cyan-900 text-sm mr-2 flex items-center">
                            Finalizar turno
                        </span>
                        <div class=" text-white bg-cyan-500 hover:bg-cyan-600 focus:ring-2 focus:ring-cyan-300 font-bold rounded-lg text-xs p-1 shadow "
                            style="z-index: 30;">

                            <span class="flex items-center">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                            </span>
                        </div>
                    </button>
                }
                <div class="w-full flex items-center justify-end">
                    <cd-timer #basicTimer class="font-semibold ml-4 text-[20px]" [autoStart]="false"
                    (onTick)="handleOnTickTimer()"></cd-timer>
                </div>
			</nz-page-header-extra>
			<nz-page-header-tags>
				<div class="flex items-center w-full justify-between">
					<span [ngClass]="orderProcess.status?.cssClassName">
						{{ orderProcess.status?.name }}
					</span>
					@if (orderProcess.workingMachinesOnProcesses?.length === 1) {
					<span
						class="bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900">
						Proceso inicializado en máquina
					</span>
					}
				</div>
			</nz-page-header-tags>
			<nz-breadcrumb nz-page-header-breadcrumb>
				<nz-breadcrumb-item>
					<a [routerLink]="'/production-orders'">
						<span>Órdenes</span>
					</a>
				</nz-breadcrumb-item>

				<nz-breadcrumb-item>
					<a [routerLink]="['/production-orders']" [queryParams]="{ customerName: order.customers?.name }">
						<span>{{ order.customers?.name || '-' }}</span>
					</a>
				</nz-breadcrumb-item>

				<nz-breadcrumb-item>
					@if(canReadKey('productionOrderDetail')){
					<a [routerLink]="['/production-orders/', idOrder]">
						<span>Orden {{idValueToShow}} - {{ order.description }}</span>
					</a>
					}@else{
					Orden {{idValueToShow}} - {{ order.description }}
					}
				</nz-breadcrumb-item>

				<nz-breadcrumb-item>
					{{ orderProcess ? orderProcess.productionProcess.name : "" }}
				</nz-breadcrumb-item>
			</nz-breadcrumb>

			@if (orderProcess) {

			<nz-page-header-content>
				<div nz-row nzJustify="center" [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="pb-4">
					<div nz-col [nzXs]="{ span: 24, order: 1 }" [nzSm]="{ span: 24, order: 1 }"
						[nzMd]="{ span: 24, order: 1 }" [nzLg]="{ span: 12, order: 1 }" class="px-4 pb-4">
						<nz-descriptions nzSize="small" [nzColumn]="{ xxl: 3, xl: 3, lg: 2, md: 2, sm: 2, xs: 1 }">
							<nz-descriptions-item nzTitle="Núm. Orden" [nzSpan]="1">
								<b>{{idValueToShow}}</b>
							</nz-descriptions-item>
							<nz-descriptions-item nzTitle="Pedido" [nzSpan]="1">
								<b>{{ order.reference !== '' ? order.reference : 'Sin referencia' }}</b>
							</nz-descriptions-item>
							<nz-descriptions-item nzTitle="Fecha de entrega" [nzSpan]="1"><b>{{
									(order.deliveryDate
									| date: "dd/MM/YYYY") || "Sin fecha"
									}}</b>
							</nz-descriptions-item>
							<nz-descriptions-item nzTitle="Fecha de inicio" [nzSpan]="1"><b>{{
									(orderProcess.productionTime?.startDate
									| date: "dd/MM/YYYY") || "Sin fecha"
									}}</b>
							</nz-descriptions-item>
							<nz-descriptions-item nzTitle="Proceso" [nzSpan]="1"><b>{{
									orderProcess.productionProcess!.name
									}}</b>
							</nz-descriptions-item>
							<nz-descriptions-item nzTitle="Máquina" [nzSpan]="1"><b>{{
									orderProcess.machine
									? orderProcess.machine.name
									: "CUALQUIERA DE " +
									orderProcess.productionProcess!
									.name
									}}</b>
							</nz-descriptions-item>
							<nz-descriptions-item nzTitle="Cliente" [nzSpan]="3"><b>{{
									order.customers?.name
									}}</b></nz-descriptions-item>
							<nz-descriptions-item nzTitle="Descripción" [nzSpan]="3">
								<b>{{ order.description }}</b>
							</nz-descriptions-item>
						</nz-descriptions>
					</div>

					<div nz-col [nzXs]="{ span: 24, order: 2 }" [nzSm]="{ span: 24, order: 2 }"
						[nzMd]="{ span: 12, order: 3 }" [nzLg]="{ span: 12, order: 3 }" class="px-4 pb-4">
						<div nz-row [nzJustify]="innerWidth > 900 ? 'end': 'center'"
							class="max-h-[100px] md:max-h-[150px]">
							<button nz-col [nzOrder]="1" nzXs="6" type="button" (click)="startProduction()"
								[disabled]="orderProcess.status?.isEndingStatus || orderProcess.statusId === StatusEnum.CANCELLED || (!orderProcess.status?.isEndingStatus && !orderProcess.status?.isStartingStatus && !orderProcess.status?.isPauseStatus)"
								class="{{
									orderProcess.status?.isEndingStatus || orderProcess.statusId === StatusEnum.CANCELLED || (!orderProcess.status?.isEndingStatus && !orderProcess.status?.isStartingStatus && !orderProcess.status?.isPauseStatus)
												? 'bg-green-900 text-gray-300 opacity-70'
												: 'bg-green-400 hover:bg-green-300 text-white'
										}} justify-center max-w-[100px] md:max-w-[150px] w-full max-h-[100px] md:max-h-[150px] h-full focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center mr-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">
								<svg xmlns="http://www.w3.org/2000/svg" class="{{
									orderProcess.status?.id === StatusEnum.IN_PROGRESS
													? 'animate-ping'
													: ''
											}} w-full h-full m-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1">
									<path stroke-linecap="round" stroke-linejoin="round"
										d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
								</svg>
							</button>
							<button nz-col [nzOrder]="2" nzXs="6" type="button" (click)="pauseProcess()"
								[disabled]="orderProcess.status?.isEndingStatus || orderProcess.status?.isPauseStatus || orderProcess.status?.isStartingStatus || orderProcess.statusId === StatusEnum.CANCELLED"
								class="{{
									orderProcess.status?.isEndingStatus || orderProcess.status?.isPauseStatus || orderProcess.status?.isStartingStatus || orderProcess.statusId === StatusEnum.CANCELLED
												? 'bg-yellow-900 text-gray-300 opacity-70'
												: 'bg-yellow-300 hover:bg-yellow-300 text-white'
										}} justify-center max-w-[100px] md:max-w-[150px] w-full max-h-[100px] md:max-h-[150px] h-full focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-3xl text-sm p-2.5 text-center inline-flex items-center mr-2 dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">
								<svg xmlns="http://www.w3.org/2000/svg" class="{{
									orderProcess.status?.id === StatusEnum.PAUSED
													? 'animate-ping'
													: ''
											}} w-full h-full m-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
									<path stroke-linecap="round" stroke-linejoin="round" d="M10 9 v6 m4-6 v6 z" />
								</svg>
							</button>
							<button nz-col [nzOrder]="3" nzXs="6" type="button" (click)="stopButtonAction()" [disabled]="
									orderProcess.status?.isEndingStatus || orderProcess.status?.isStartingStatus || orderProcess.statusId === StatusEnum.CANCELLED
										" class="{{
									orderProcess.status?.isEndingStatus || orderProcess.status?.isStartingStatus || orderProcess.statusId === StatusEnum.CANCELLED
												? 'bg-red-900 text-gray-300 opacity-70'
												: 'bg-red-500 hover:bg-red-300 text-white'
										}} justify-center max-w-[100px] md:max-w-[150px] w-full max-h-[100px] md:max-h-[150px] h-full focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center mr-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
								<svg xmlns="http://www.w3.org/2000/svg" class="w-full h-full m-1" fill="none"
									viewBox="0 0 24 24" stroke="currentColor" stroke-width="1">
									<path stroke-linecap="miter" stroke-linejoin="miter"
										d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z" />
								</svg>
							</button>
						</div>
					</div>
				</div>
			</nz-page-header-content>
			}
		</nz-page-header>
	</div>

	<div class="flex flex-wrap justify-center gap-4 mb-6">
		<div class="min-w-[200px]">
			<nz-card nzTitle="Progreso"
				style="background:rgb(255, 255, 255); padding: 12px !important; filter: drop-shadow(0 4px 4px rgb(0 0 0 / 0.15));"
				class="font-bold rounded-md h-full">
				<div class="flex justify-center items-center h-full w-full">
					<nz-progress nz-tooltip nzType="circle" [nzPercent]="calculateProgress()" [nzWidth]="100"
						class="flex justify-center items-center text-center">
					</nz-progress>
				</div>
			</nz-card>
		</div>
		<div class="min-w-[200px]">
			<nz-card nzTitle="Tiempo restante estimado"
				style="background:rgb(255, 255, 255); padding: 12px !important; filter: drop-shadow(0 4px 4px rgb(0 0 0 / 0.15));"
				class="font-bold rounded-md h-full">
				<div class="flex justify-center items-center h-full w-full text-[20px]">
					{{ formatEstimatedTime() }}
				</div>
			</nz-card>
		</div>
		@for (sensor of orderProcess.machine?.sensors; track sensor.id) {
		@if (sensor.showInScreen) {
		<div class="min-w-[200px]">
			<app-sensor-card [sensor]="sensor" [articleId]="orderProcess.finalProducts?.[0]?.article?.id"
				[quantityToProduce]="orderProcess.finalProducts?.[0]?.quantityToProduce || 0">
			</app-sensor-card>
		</div>
		}
		}
	</div>

	<div nz-row nzJustify="center" [nzGutter]="{ xs: 16, sm: 16, md: 24, lg: 32 }" class="pb-4">
		@if (showButton('btnWatchRawMaterialToUse')) {
		<button (click)="openRawMaterialsToUseModal()"
			class="text-white bg-teal-500 hover:bg-teal-800 focus:ring-4 focus:ring-teal-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-teal-600 dark:hover:bg-teal-700 focus:outline-none dark:focus:ring-teal-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Materias primas a utilizar
		</button>
		}
		<!-- TODO: habiliatar por permisos -->
		<!-- @if (showButton('btnWatchRawMaterial')) { -->
		<button (click)="openUsedRawMaterialsModal()"
			class="text-white bg-teal-500 hover:bg-teal-800 focus:ring-4 focus:ring-teal-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-teal-600 dark:hover:bg-teal-700 focus:outline-none dark:focus:ring-teal-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Materias primas utilizadas
		</button>
		<!-- } -->

		@if (showButton('btnSelectFinalProducts')) {
		<button (click)="openSelectFinalProducts()"
			class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Seleccionar productos finales
		</button>
		}
		@if (showButton('btnWatchFinalProducts')) {
		<button (click)="openFinalProducts()"
			class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Productos finales
		</button>
		}
		@if (showButton('btnTraceability')) {
		<button (click)="openTraceabilityByOrderProcess(false)"
			class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Trazabilidad
		</button>
		}
		@if (showButton('btnNewScrap')) {
		<button (click)="openCreateScrapsModal()"
			class="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Nueva tara
		</button>
		}
		@if (showButton('btnWatchScraps')) {
		<button (click)="openScrapsModal()"
			class="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Ver taras
		</button>
		}
		@if (showButton('btnNewLoss')) {
		<button (click)="openCreateLossesModalWithOrigin(LossOrScrapSourceEnum.FINAL_PRODUCT)"
			class="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Nueva merma
		</button>
		}
		@if (showButton('btnWatchLosses')) {
		<button (click)="openLossesModal()"
			class="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Ver mermas
		</button>
		}
		@if (showButton('btnWatchPauses')) {
		<button (click)="openPausesModal()"
			class="text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Ver pausas
		</button>
		}
		@if (showButton('btnWatchImages')) {
		<button
			class="text-white bg-lime-500 hover:bg-lime-600 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Ver imágenes
		</button>
		}
		@if (showButton('btnWatchPdf')) {
		<button
			class="text-white bg-lime-500 hover:bg-lime-600 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Ver PDFs
		</button>
		}
		@if (showButton('btnNewComment')) {
		<button
			class="text-white bg-purple-600 hover:bg-purple-700 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Nuevo comentario
		</button>
		}
		@if (showButton('btnWatchComments')) {
		<button
			class="text-white bg-purple-600 hover:bg-purple-700 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Ver comentarios
		</button>
		}
		@if (showButton('btnNewQualityControl') && orderProcess.productionProcess.qualityControl &&
		orderProcess.finalProducts && orderProcess.finalProducts.length > 0) {
		<button (click)="openQualityControlModal(orderProcess.finalProducts!)"
			class="text-white bg-orange-600 hover:bg-orange-700 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Nuevo control de calidad
		</button>
		}
		@if (showButton('btnPrintStickers')) {
		<button (click)="openPrintStickersModal()"
			class="text-white bg-sky-300 hover:bg-sky-400 focus:ring-4 focus:ring-blue-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Imprimir etiquetas
		</button>
		}
		@if (isConfeccionProcess()) {
		<button (click)="openPackagingDestinationTypeModal()"
			class="text-white bg-indigo-500 hover:bg-indigo-600 focus:ring-4 focus:ring-indigo-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-indigo-600 dark:hover:bg-indigo-700 focus:outline-none dark:focus:ring-indigo-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6">
			Generar nueva etiqueta
		</button>
		<button (click)="openPalletListModal()"
			class="text-white bg-orange-500 hover:bg-orange-600 focus:ring-4 focus:ring-orange-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-orange-600 dark:hover:bg-orange-700 focus:outline-none dark:focus:ring-orange-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6">
			Etiqueta Palet
		</button>
		}
		@if (showButton('btnWatchHistory')) {
		<button (click)="openOperatorHistoryModal()"
			class="text-white bg-fuchsia-300 hover:bg-fuchsia-400 focus:ring-4 focus:ring-fuchsia-300 font-semibold rounded-md text-[13px] px-4 py-2.5 mb-4 dark:bg-fuchsia-600 dark:hover:bg-fuchsia-700 focus:outline-none dark:focus:ring-fuchsia-800 min-w-[100px] max-w-[170px] w-[170px] h-[110px] mx-6 ">
			Historial Operarios
		</button>
		}
	</div>

	<div class="pb-10">
		<nz-collapse>
			<!-- Panel de Materias primas cargadas con lote -->
			<!-- @if (getRawMaterialsWithBatch().length > 0) {
			<nz-collapse-panel [nzHeader]="'Materias primas cargadas (' + getRawMaterialsWithBatch().length + ')'"
				[nzActive]="false">
				<nz-table #rawMaterialsTable [nzData]="getRawMaterialsWithBatch()" [nzShowPagination]="false"
					[nzSize]="'small'" nzBordered>
					<thead>
						<tr>
							<th>Artículo</th>
							<th>Lote</th>
							<th>Formato</th>
							<th>Cantidad</th>
							<th>Unidad</th>
							@if (hasAnyRawMaterialWithFeature(2)) {
							<th>Metros lineales</th>
							<th>Kg</th>
							}
						</tr>
					</thead>
					<tbody>
						@for (rawMaterial of rawMaterialsTable.data; track rawMaterial.id) {
						<tr>

							<td class="text-left align-middle"><strong>{{ rawMaterial.article?.name || 'Sin nombre'
									}}</strong></td>
							<td class="text-left align-middle">
								<nz-tag [nzColor]="'blue'">
									{{ rawMaterial.articleBatch?.batchNumber || rawMaterial.articleBatchId }}
								</nz-tag>
							</td>
							<td class="text-left align-middle">
								<nz-tag [nzColor]="'blue'">
									{{ rawMaterial.usedPackaging?.externalBatchNumber || rawMaterial.articleBatchId }}
								</nz-tag>
							</td>
							<td class="text-left align-middle">{{ rawMaterial.quantity }}</td>
							<td class="text-left align-middle">{{ rawMaterial.unit || '-' }}</td>
							@if (hasAnyRawMaterialWithFeature(2)) {
							<td class="text-left align-middle">{{ getRawMaterialLinearMeters(rawMaterial) |
								number:'1.2-2' }} m</td>
							<td class="text-left align-middle">{{ getRawMaterialKg(rawMaterial) | number:'1.2-2' }} kg
							</td>
							}
						</tr>
						}
					</tbody>
				</nz-table>
			</nz-collapse-panel>
			} -->

			@for (panel of panels; track panel) {
			<nz-collapse-panel [nzHeader]="panel.name" [nzActive]="panel.active" [hidden]="panel.hidden">
				@switch (panel.type) {
				@case ('finalProducts') {
				<nz-table #finalProductsTable [nzData]="orderProcess.finalProducts!" nzBordered
					[nzFrontPagination]="false" nzSize="small">
					<thead>
						<tr>
							<th>Artículo</th>
							<th>Número de lote</th>
							<th>Cantidad planificada</th>
							<th>Cantidad producida</th>
						</tr>
					</thead>
					<tbody>
						@for(finalProduct of orderProcess.finalProducts; track finalProduct.id){

						<tr>
							<td class="text-left align-middle">{{ finalProduct.article?.name }}</td>
							<td class="text-left align-middle">{{
								finalProduct.articleBatch?.batchNumber || 'N/A' }}</td>
							<td class="text-left align-middle">{{ finalProduct.quantityToProduce | number:'1.0-2' }}
								{{
								getDisplayUnit() }}</td>
							<td class="text-left align-middle">
								{{ finalProduct.quantityProduced | number:'1.0-2' }}
								{{ getDisplayUnit() }}
							</td>
						</tr>
						}
					</tbody>
				</nz-table>
				}
				@case ('articleFeatures') {
				<nz-table #articleFeaturesTable [nzData]="articleFeatureValues" nzTableLayout="auto" [nzBordered]="true"
					nzSize="small" [nzFrontPagination]="false" [nzShowPagination]="false" [nzLoading]="isLoading"
					class="pb-[100px]">
					<thead>
						<tr>
							@if(orderProcess.finalProducts && orderProcess.finalProducts.length > 1){
							<th>Artículo</th>
							}
							<th>Característica</th>
							<th>Valor</th>
						</tr>
					</thead>
					<tbody>
						@for (articleFeatureValue of articleFeatureValues; track articleFeatureValue; let i = $index) {
						@if(articleFeatureValue.showOnScreen){
						<tr>
							@if(orderProcess.finalProducts && orderProcess.finalProducts.length > 1){
							<td class="text-left align-middle">
								{{ articleFeatureValue.article.name }}
							</td>
							}
							<td class="text-left align-middle">
								{{ articleFeatureValue.feature.feature }}
							</td>
							<td>
								{{ articleFeatureValue?.value }}
							</td>
						</tr>
						}
						}
					</tbody>
				</nz-table>
				}

				@case ('machineMeasurements') {
				<nz-table #machineValuesTable [nzData]="machineMeasurements" nzTableLayout="auto" [nzBordered]="true"
					nzSize="small" [nzFrontPagination]="false" [nzShowPagination]="false" [nzLoading]="isLoading"
					class="pb-[100px]">
					<thead>
						<tr>
							<th>Artículo</th>
							<th>Medida</th>
							<th>Valor</th>
						</tr>
					</thead>
					<tbody>
						@for (data of machineValuesTable.data; track data; let i = $index) {
						<tr>
							<td class="text-left align-middle">
								{{ data?.article?.name || 'N/A' }}
							</td>
							<td class="text-left align-middle">
								{{ data?.machineMeasurement?.measurement }}
							</td>
							<td>
								{{ data?.value }}
							</td>
						</tr>
						}
					</tbody>
				</nz-table>
				}
				}

			</nz-collapse-panel>
			}
		</nz-collapse>
	</div>
</div>

<!-- Referencia oculta para evitar errores de compilación por componentes standalone usados dinámicamente -->
@if (false) { <app-modal-apply-temp-loaded-raw-materials></app-modal-apply-temp-loaded-raw-materials> }
}
